(() => {
  angular
    .module('gm.common.conversion')
    .filter('gmyConvertCurrency', gmyConvertCurrency);

  function gmyConvertCurrency(
    GmyCurrencyConverter
  ) {
    'ngInject';

    const convertCurrency = (currencyAmount, fromCurrencyCode, toCurrencyCode) => {
      if (fromCurrencyCode === toCurrencyCode) {
        return currencyAmount;
      }

      return GmyCurrencyConverter.fromCurrencyToCurrency(fromCurrencyCode, toCurrencyCode,
        currencyAmount);
    };

    convertCurrency.$stateful = true;
    return convertCurrency;
  }
})();
